


















































































































































































































































































































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// Models
import { PropOptionSelect } from '@/models'
import {
    AssignmentEmployeeModel,
    EmployeeModel,
    CostCenterModel,
    Position,
    HeadquarterModel,
    AreaModel,
    WorkShiftModel,
    RateLunch
} from '@/models/config'

// components
import { Input, Select, SwitchToggle, Select2 } from '@/components/form'

// services
import {
    CostCenterService,
    PositionService,
    HeadquarterService,
    AreaService,
    WorkShiftService,
    RatesLunchService
} from '@/services/config'

// constants
import {
    optionsWorkType,
    optionsCondition,
    optionsWorkCategory,
    optionsTypeOfContract,
    optionsLaborRegime
} from '@/constants'

@Component({
    name: 'AssignmentSectionForm',
    components: {
        Select,
        SwitchToggle,
        Select2,
        Input
    }
})
export default class AssignmentSectionForm extends Vue {
    @Prop({ type: Object, required: true }) assignment!: AssignmentEmployeeModel
    @Prop({ type: Object, required: true }) empleado!: EmployeeModel
    @Prop({ type: Object, default: () => ({}) }) validations!: {}
    costCenters: CostCenterModel[]|[] = []
    positions: Position[]|[] = []
    headquarters: HeadquarterModel[]|[] = []
    areas: AreaModel[]|[] = []
    workShifts: WorkShiftModel[]|[] =[]
    rateLunchs: RateLunch[] = []
    optionsWorkType = optionsWorkType
    optionsCondition = optionsCondition
    optionsWorkCategory = optionsWorkCategory
    optionsTypeOfContract = optionsTypeOfContract
    optionsLaborRegime = optionsLaborRegime

    mounted () {
        this.getAll()
    }

    async getAll () {
        this.rateLunchs = await RatesLunchService.getAllActivated()
        this.positions = await PositionService.getAllActivated()
        this.costCenters = await CostCenterService.getCostCenterActivated()
        this.headquarters = await HeadquarterService.getAllActivate()
        this.areas = await AreaService.getActivated()
        this.workShifts = await WorkShiftService.getActivated()
    }

    get optionsCostCenter (): PropOptionSelect[] {
        const costCenter: PropOptionSelect[] = []
        this.costCenters.forEach(cost => {
            if (cost?.id) {
                costCenter.push({
                    value: cost.id,
                    text: cost.name
                })
            }
        })
        return costCenter
    }

    get optionsPositions (): PropOptionSelect[] {
        const positions: PropOptionSelect[] = []
        this.positions.forEach(pos => {
            if (pos.id) {
                positions.push({
                    value: pos.id,
                    text: pos.name
                })
            }
        })
        return positions
    }

    get headquarterOp (): PropOptionSelect[] {
        const headquarters: PropOptionSelect[] = []
        this.headquarters.forEach(headq => {
            if (headq.id) {
                headquarters.push({
                    value: headq.id,
                    text: headq.name
                })
            }
        })
        return headquarters
    }

    get ratesOp (): PropOptionSelect[] {
        return this.rateLunchs.map(rate => {
            return {
                value: rate.id ?? 0,
                text: `${rate.name} - S/. ${rate.price}`
            }
        })
    }

    get areasOptions (): PropOptionSelect[] {
        const areas: PropOptionSelect[] = []
        this.areas.forEach(area => {
            if (area.id) {
                areas.push({
                    text: area.name,
                    value: area.id
                })
            }
        })
        return areas
    }

    get subAreas (): PropOptionSelect[] {
        const areaSelected = this.areas.find(area => area.id === this.assignment.area_id)
        if (areaSelected) {
            const subAreasInArea = areaSelected.subAreas
            const subAreas: PropOptionSelect[] = []
            if (subAreasInArea) {
                subAreasInArea.forEach(sub => {
                    subAreas.push({
                        text: sub.name,
                        value: sub?.id ? sub.id : null
                    })
                })
            }
            return subAreas
        }
        return []
    }

    get optionsWorkShifts (): PropOptionSelect[] {
        const workShifts: PropOptionSelect[] = []
        this.workShifts.forEach(workS => {
            if (workS.id) {
                workShifts.push({
                    text: workS.name,
                    value: workS.id
                })
            }
        })
        return workShifts
    }
}
